import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import edit from '../../resources/images/estrategas/tools/edit.svg';
import view from '../../resources/images/estrategas/tools/view.svg';
import {
  EDIT_INDICATORS,
  HEADER,
  INDICATORS,
  URL_SERVER,
  VIEW_ACTIONS,
  UPLOAD_ACTIONS,
  SAVE_AUDIT_REPORT
} from '../../utils/constants';
import * as Request from '../../service/data-info-chart/requestsUtil';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import Axios from 'axios';
import Save from '../../components/buttons/save';


let Loader = require('react-loader');

class correctiveActions extends Component {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.editActions = this.editActions.bind(this);
    this.viewActions = this.viewActions.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      data: [],
      modal: false,
      openActions: null,
      openActionsPrev: null,
      newActions: null,
      newActionsPrev: null,
      closedActions: null,
      closedActionsPrev: null,
      key: null,
      loaded: false,
    };
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  editActions() {

    this.setState({ loaded: false });

    let closedActions = (this.state.closedActions!=null&&this.state.closedActions!==""&&!isNaN(this.state.closedActions)&&this.state.closedActions>=0)
      ?this.state.closedActions:this.state.closedActionsPrev;
    let openActions = (this.state.openActions!=null&&this.state.openActions!==""&&!isNaN(this.state.openActions)&&this.state.openActions>=0)
      ?this.state.openActions:this.state.openActionsPrev;
    let newActions = (this.state.newActions!=null&&this.state.newActions!==""&&!isNaN(this.state.newActions)&&this.state.newActions>=0)
      ?this.state.newActions:this.state.newActionsPrev;

    let params = {
      'closedActions': closedActions,
      'newActions': newActions,
      'openActions': openActions,
      'date': this.props.date
    };
    Request.postFetch(EDIT_INDICATORS, params)
      .then(() => {
        this.setState({ key: Math.random() });
      });
    this.toggle();
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
  }

  viewActions(param){
    Request.getFetch2(VIEW_ACTIONS+this.props.date+'/'+param).then(url=>{
      window.open(url)
    })
  }

  render() {

    const headerStyle = {
      background: HEADER.BACKCOLOR,
      color: HEADER.COLOR,
      fontSize: HEADER.FONTSIZE,
      textAlign: 'left'
    };

    const header = [{
      Header: 'Abiertas nuevas del mes',
      accessor: 'newActions',
      headerStyle: headerStyle,
    /*  Cell: row => (<div className='d-flex justify-content-between'>
        <div >{row.value}</div><div className='corrAct-view'><img id='1' src={view} alt='' onClick={()=>this.viewActions(1)}/></div>
      </div>)*/
    },
      {
        Header: 'Acciones cerradas del mes',
        accessor: 'closedActions',
        headerStyle: headerStyle,
       /* Cell: row => (<div className='d-flex justify-content-between'>
          <div >{row.value}</div><div className='corrAct-view'><img id='2' src={view} alt='' onClick={()=>this.viewActions(2)}/></div>
        </div>)*/
      },
      {
        Header: 'Acciones abiertas totales',
        accessor: 'openActions',
        headerStyle: headerStyle,
        Cell: row => (<div className='d-flex justify-content-between'>
          <div >{row.value}</div><div className='corrAct-view'><img id='3' src={view} alt='' onClick={()=>this.viewActions(3)}/></div>
        </div>)
      }];

    const data = [{
      openActions: null,
      closedActions: null,
      newActions: null,
    }];

    let dataTable = (this.state.data !== null) ? [this.state.data] : data;

    let classUser = this.props.authorization ? 'quality-edit' : 'quality-edit-unauthorized';

    return (<div className='container-fluid back-color-grey'>
      <div className={classUser}>
        <img src={edit} title="Editar" alt=" " onClick={this.toggle}/>
      </div>
      <Modal isOpen={this.state.modal} toggle={this.toggle}>
        <ModalHeader className='header-modal'
                     toggle={this.toggle}>Periodo {this.props.dateModal}</ModalHeader>
        <ModalBody>
          <div className='d-flex justify-content-start  m-3'>
            <p className='mb-0 mr-2'>Acciones nuevas del mes:</p>
            <Input placeholder="# número" type="text" name="newActions" id="new"
                   value={this.state.newActions} onChange={this.handleChange}
                   style={{ width: '50%' }}/>
            <div className='modal-edit'>
              {/*<Save url={UPLOAD_ACTIONS} authorization={this.props.authorization}
                    date={this.props.date} bu={1}/>*/}
            </div>
          </div>
          <div className='d-flex justify-content-start m-3'>
            <p className='mb-0 mr-2'>Acciones cerradas del mes:</p>
            <Input placeholder="# número" type="text" name="closedActions" id="closed"
                   value={this.state.closedActions} onChange={this.handleChange}
                   style={{ width: '50%' }}/>
            <div className='modal-edit'>
              {/*<Save url={UPLOAD_ACTIONS} authorization={this.props.authorization}
                    date={this.props.date} bu={2}/>*/}
            </div>
          </div>
          <div className='d-flex justify-content-start m-3'>
            <p className='mb-0 mr-2'>Acciones abiertas totales:</p>
            <Input placeholder="# número" type="text" name="openActions" id="open"
                   value={this.state.openActions} onChange={this.handleChange}
                   style={{ width: '50%' }}/>
            <div className='modal-edit'>
              <Save url={UPLOAD_ACTIONS} authorization={this.props.authorization}
                    date={this.props.date} bu={3}/>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.editActions}>Aceptar</Button>{' '}
          <Button color="danger" onClick={this.toggle}>Cancelar</Button>
        </ModalFooter>
      </Modal>
      <div className='container p-md-5 pt-5 pb-5 pl-0 pr-0'>
        <div className='container-fluid table-title'>
          Acciones correctivas
        </div>
        <div className='borderTable' key={this.state.key}>
          <ReactTable
            columns={header}
            data={dataTable}
            showPageJump={false}
            noDataText="¡No hay acciones que mostrar!"
            defaultPageSize={1}
            showPagination={false}
            previousText={'Anterior'}
            pageText={'Página'}
            ofText={'de'}
            rowsText={'registros'}
            nextText={'Siguiente'}
            sortable={false}
            pages={this.state.pages} // should default to -1 (which means we don't know how many pages we have)
            manual // informs React Table that you'll be handling sorting and pagination server-side
            onFetchData={(state) => {
              // show the loading overlay
              this.setState({ loading: true });
              // fetch your data
              Axios.get(URL_SERVER + INDICATORS + this.props.date, {
                method: 'get',
                headers: { 'Authorization': sessionStorage.getItem('token') },
              })
                .then((res) => {
                  // Update react-table
                  this.setState({
                    data: res.data,
                    openActionsPrev: res.data.openActions,
                    closedActionsPrev: res.data.closedActions,
                    newActionsPrev: res.data.newActions,
                    loaded: true,
                  });
                });
            }}

          />
        </div>
        <Loader loaded={this.state.loaded}/>
      </div>
    </div>);

  }
}

export default correctiveActions;



// WEBPACK FOOTER //
// ./src/components/tables/correctiveActions.js